import React from 'react'
import { Header, Button, Message, Icon, Segment } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

import LocationsList from './LocationsList/LocationsList'

const usageTip = `Listasta löydät kaikki järjestelmässä olevat kohteet. 
Kun kohteelle valitaan asiakas, sitä voidaan valvoa myös asiakkaan jaettavan 
linkin kautta (löytyy asiakkaat osiosta).`

const Locations = () => {
    return (
        <div>
            <Header as="h2">Listaus kohteista</Header>

            <Message info icon="idea" content={usageTip} />

            <Segment size="large">
                <LocationsList />

                <Button primary as={Link} to="/admin/">
                    <Icon name="arrow left" />
                    Takaisin
                </Button>
            </Segment>

        </div>
    )
}

export default Locations


// WEBPACK FOOTER //
// ./src/Admin/Locations/Locations.js